
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(96(59|71)|1(015|411|635)|(31|407|7)5|4167|5699|5837)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
